import resource from "../../Util/resources";

import DefaultLayout from "../../Components/Layout/DefaultLayout.vue";
import Index from './Components/IndexPage.vue';
import Edit from './Components/EditPage.vue';
import Create from './Components/CreatePage.vue';

const routes = [{
    path: '/Newsroom/',
    alias: '/Newsroom/Index',
    component: DefaultLayout,
    meta: {
        title: resource('Newsroom_Index_Title'),
        breadcrumb: resource('Breadcrumb_Newsroom')
    },
    children: [{
        name: 'newsroom-index',
        path: '',
        component: Index
    },{
        name: 'newsroom-edit',
        path: 'Edit/:id',
        component: Edit,
        meta: {
            title: resource('Newsroom_Edit_Header'),
            header: resource('Newsroom_Edit_Header'),
            breadcrumb: resource('Breadcrumb_Newsroom_Edit')
        }
    }, {
        name: 'newsroom-create',
        path: 'Create',
        component: Create,
        meta: {
            title: resource('Newsroom_Create_Title'),
            header: resource('Newsroom_Create_Header'),
            breadcrumb: resource('Breadcrumb_Newsroom_Create')
        }
    }]
}];

export {
   routes 
}